import { List } from "@mui/material";
import DrawerListItem from "./DrawerListItem";

export default function DrawerList({ tabs, tab_sx, ...props }) {
    return (
        <List  dense {...props}>
            {tabs?.map(tab => (<DrawerListItem key={tab?.title} tab={tab} tab_sx={tab_sx} />))}
        </List>
    )
}
